// extracted by mini-css-extract-plugin
export default {"modalBodyLoading":"MyDonationsModal_modalBodyLoading__eJVHs"};